export const EXTERNAL_TOOLS_QUERY_KEY = 'external-tools';
export const EXTERNAL_TOOL_CATEGORIES_QUERY_KEY = 'external-tool-categories';
